export const lightPalette = {
  // Primary (Header) colors
  headerColor: '#d48216',
  headerBrightColor: '#e9a957',
  headerDimColor: '#996016',
  headerTransparentColor: 'rgba(212, 130, 22, 0.8)',
  headerTransparentThinColor: 'rgba(212, 130, 22, 0.2)',

  // Background colors
  background: '#ffffff',
  paperColor: '#ffffff',
  paperColorDim: '#fdf6ed',
  paperColorDim2: '#e9d2b4',
  paperColorTransparent: 'rgba(255, 255, 255, 0.6)',
  paperColorInput: '#fdf8f1',
  paperColorDivider: '#d6c9b8',

  // Text colors
  textColor: '#000000',
  textColorSecondary: '#000000',

  // Status colors
  successText: '#1ba100',
  successMain: '#d9f1d4',
  errorText: '#da2f23',
  errorMain: '#f8d4d2',
  warningText: '#e09a17',
  warningMain: '#f5e6cb',
  infoText: '#03a0a0',
  infoMain: '#d8f3f3',

  // Secondary colors
  secondaryBright: '#bdbdbd',
  secondaryMain: '#9b9b9b',

  // Action colors
  actionDisabled: '#9b9b9b',
  actionSelected: '#ff9100',

  // Additional
  mapBackground: '#1e1f1a',
  mapTextColor: '#ffffff',
  achievementStroke: '#d96343',
  disabledOverlay: 'rgba(0, 0, 0, 0.25)',
  shadowColor: '#20181d'
}
